function Arrow({ className }: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      className={`h-4 w-4 ${className}`}
      stroke="#b4b4b4"
      fill="currentColor"
    >
      <path
        d="M7 17L17 7M17 7H8M17 7V16"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default Arrow;
